import React from 'react'

const pointsInfo=()=>{
    return(
        <div style={{borderRadius:'10px',height:'fit-content',padding:'30px',margin:'30px',backgroundColor:'rgba(255,255,255,0.5)',border:'1px solid #2c3e50',textAlign:'center'}}>
        <h2>Како да соберам вело-поени?</h2>
        <hr/>
        <ol>
            <p>Секој лајк на вашите објавени возења ви придонесува 1 вело поен</p>
            <p>Секоја додадена и прифатена вело патека придонесува 30 вело-поени кон вашиот профил</p>
            <p>Секое додадено и прифатено место придонесува 10 вело-поени кон вашиот профил</p>
        </ol>
        <h2>Што да правам со моите собрани вело-поени?</h2>
        <hr/>
        <ul>
            <p>Со 500 поени добивате можност да додавате кон главната мапа без проверување од модератор</p>
            <p>Со 1000 поени добивате можност да станете модератор</p>
            <p>Добивате попусти во вело-сервиси/продавници и слично (Доаѓа наскоро)</p>
        </ul>
    </div>
    )
}

export default pointsInfo;